import api from "@/api";
export default class RepairDamage {
  constructor(_default) {
    if (_default !== undefined) {
      this._default = _default;
      for (let prop in _default) {
        this[prop] = _default[prop];
      }
    }
  }

  static async list(params) {
    const res = await api.get(`/api/v1/repair/damage_part/`, params);
    if (res) return res.data;
    return null;
  }

  static async store(payload) {
    const res = await api.post(`/api/v1/repair/create/damage_part/`, payload);
    if (res) return res.data.data;
    return null;
  }

  static async update(payload) {
    const res = await api.put(
      `/api/v1/repair/update/damage_part/${payload.id}/`,
      payload
    );
    if (res) return res.data.data;
    return null;
  }
}
